var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeHideIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2239_8765)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 96,
    height: 96,
    rx: 48,
    fill: "black",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges",
    id: "eye-background"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8199 60.8198C64.3778 61.2318 64.0232 61.7286 63.7773 62.2806C63.5313 62.8326 63.3991 63.4285 63.3884 64.0327C63.3777 64.6369 63.4889 65.2371 63.7152 65.7974C63.9415 66.3577 64.2784 66.8667 64.7057 67.2941C65.133 67.7214 65.642 68.0582 66.2024 68.2846C66.7627 68.5109 67.3629 68.622 67.9671 68.6114C68.5713 68.6007 69.1672 68.4685 69.7192 68.2225C70.2712 67.9766 70.768 67.6219 71.1799 67.1798",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8199 60.8198C64.3778 61.2318 64.0232 61.7286 63.7773 62.2806C63.5313 62.8326 63.3991 63.4285 63.3884 64.0327C63.3777 64.6369 63.4889 65.2371 63.7152 65.7974C63.9415 66.3577 64.2784 66.8667 64.7057 67.2941C65.133 67.7214 65.642 68.0582 66.2024 68.2846C66.7627 68.5109 67.3629 68.622 67.9671 68.6114C68.5713 68.6007 69.1672 68.4685 69.7192 68.2225C70.2712 67.9766 70.768 67.6219 71.1799 67.1798",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0952 53.62C66.7272 53.5413 67.3634 53.5012 68.0002 53.5C78.5002 53.5 83.0002 64 83.0002 64C82.3296 65.4357 81.4885 66.7854 80.4952 68.02",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.915 55.915C56.9319 57.947 54.5448 60.7379 53 64C53 64 57.5 74.5 68 74.5C70.8739 74.5077 73.6862 73.6677 76.085 72.085",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 49L83 79",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 17,
    width: 94,
    height: 94,
    rx: 47,
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2239_8765",
    x: 0,
    y: 0,
    width: 136,
    height: 136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2239_8765"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2239_8765",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHideIcon);
export default __webpack_public_path__ + "static/media/eye-hide-icon.488eed8d.svg";
export { ForwardRef as ReactComponent };